module.exports = __webpack_public_path__ + "img/icon_ct_arr.03286d5b.svg";